module.exports = __webpack_public_path__ + "static/img/credicompras.d27117c4.svg";